import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { CheckIcon, LinkIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { useCopyLinkButtonReskin } from 'src/app/pages/starterDashboardV2/shared/hooks';

type CopyLinkButtonProps = {
	shareUrl: string;
};

export const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({ shareUrl }) => {
	const { data, actions } = useCopyLinkButtonReskin({ shareUrl });
	const { translate } = useI18n();
	return (
		<Button
			data-testid="copy-link-share-button"
			data-qa="copy-link-share-button"
			variant="secondary"
			size="small"
			leadingIcon={
				data.copied ? (
					<CheckIcon
						data-testid="copy-link-icon-success"
						data-qa="copy-link-icon"
						aria-label={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.copy_success')}
						className="text-icon-success"
					/>
				) : (
					<LinkIcon
						data-testid="copy-link-icon"
						data-qa="copy-link-icon"
						aria-label={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.copy_button')}
						className="text-typography-strong"
					/>
				)
			}
			className="bg-fill-inverse-strong text-typography-strong flex w-full items-center justify-center gap-1.5 px-3 py-2"
			onClick={actions.handleShare}
		>
			{data.copied ? (
				<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.copy_success" />
			) : (
				<Text fontWeight="bold" className="leading-5">
					<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.copy_button" />
				</Text>
			)}
		</Button>
	);
};
